import * as React from 'react';
import * as Icons from '../../icons';

export type IconName = keyof typeof Icons; // Derive valid icon names dynamically

export interface IconProps extends React.SVGProps<SVGSVGElement> {
    iconName: IconName; // Enforce only valid icon names
    size?: 'sm' | 'md' | 'lg';
    className?: string;
}

const sizeClasses = {
    sm: 'w-4 h-4', // 16px
    md: 'w-6 h-6', // 24px (default)
    lg: 'w-8 h-8', // 32px
};

export const IconLoader: React.FC<IconProps> = ({ iconName, size = 'md', className = '', ...props }) => {
    const SelectedIcon = Icons[iconName]; // Dynamically retrieve the icon component

    if (!SelectedIcon) {
        console.error(`Icon "${iconName}" not found.`);
        return null; // Fallback for invalid icons
    }

    // default fill color class can be overwritten by passing in a different fill class
    const hasFillClass = /^(fill-[\w-]+)|\s(fill-[\w-]+)/.test(className);
    const defaultClass = hasFillClass ? '' : 'fill-system-on-surface-variant';
    return (
        <SelectedIcon className={`${sizeClasses[size]} ${defaultClass} ${className}`} viewBox='0 0 24 24' {...props} />
    );
};
